import PropTypes, { bool } from "prop-types";
import React from "react";

import styled from "styled-components/macro";

import { Input, Label } from "./Styles";

ZipField.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  labelOverride: PropTypes.string,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  countryID: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  hideInternalFocusStyles: PropTypes.bool,
  autoComplete: PropTypes.oneOf(["on", "off"]),
  style: PropTypes.object,
  disabled: bool,
};

export function ZipField({
  value = "",
  onChange,
  labelOverride,
  name = "zip",
  placeholder,
  countryID = 1,
  hideInternalFocusStyles = false,
  autoComplete,
  style,
  disabled,
}) {
  const getLabel = () => {
    if (labelOverride) return labelOverride;
    else if (countryID === 1 || countryID === "US") return "Zip";
    else return "Postal";
  };

  return (
    <Wrapper style={style}>
      {name ? <Label htmlFor={name}>{getLabel()}</Label> : null}
      <Input
        data-cy="fnrAddressZipField"
        id={name}
        name={name}
        placeholder={placeholder || getLabel()}
        value={value}
        onChange={onChange}
        hideInternalFocusStyles={hideInternalFocusStyles}
        autoComplete={autoComplete}
        disabled={disabled}
      />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  width: 100%;
  padding: 6px;
`;
